import React from 'react';
import { Trash2, Loader2 } from 'lucide-react';
import { formatDate } from '../../../lib/dateHelpers';
import { contentService } from '../../../services/ContentService';

const ProjectFolderCard = ({ batch, onClick, onDelete }) => {
  const statusInfo = contentService.helpers.formatBatchStatus(batch);
  const isProcessing = batch.status === 'processing';
  const isCompleted = batch.status === 'completed';

  // Pegar até 4 conteúdos completados para preview
  const previewContents = batch.contents
    ?.filter(c => c.status === 'completed' && c.result_url)
    .slice(0, 4) || [];

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete(batch);
    }
  };

  return (
    <div
      onClick={() => onClick && onClick(batch)}
      className="group cursor-pointer transform transition-all duration-200 hover:-translate-y-1"
    >
      <div className="relative bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-200">
        
        {/* Área de preview */}
        <div className="p-3">
          <div className="aspect-[4/3] bg-gray-50 rounded-xl overflow-hidden border border-gray-100 relative">
            {previewContents.length > 0 ? (
              <div className={`grid h-full ${
                previewContents.length === 1 ? 'grid-cols-1' :
                previewContents.length === 2 ? 'grid-cols-2' :
                'grid-cols-2'
              } gap-0.5`}>
                {previewContents.slice(0, 4).map((content, idx) => (
                  <div
                    key={content.id}
                    className={`relative bg-gray-100 overflow-hidden ${
                      previewContents.length === 3 && idx === 0 ? 'row-span-2' : ''
                    }`}
                  >
                    {content.type === 'video' ? (
                      <video
                        src={content.result_url}
                        className="w-full h-full object-cover"
                        muted
                        playsInline
                      />
                    ) : (
                      <img
                        src={content.result_url}
                        alt=""
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="w-full h-full flex items-center justify-center">
                {isProcessing ? (
                  <div className="flex flex-col items-center gap-2">
                    <div className="w-10 h-10 rounded-full bg-amber-50 flex items-center justify-center">
                      <Loader2 className="w-5 h-5 text-amber-500 animate-spin" />
                    </div>
                    <span className="text-xs text-gray-400">Gerando...</span>
                  </div>
                ) : (
                  <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
                    <svg className="w-5 h-5 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                )}
              </div>
            )}

            {/* Progress bar overlay */}
            {isProcessing && (
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gray-200">
                <div 
                  className="h-full bg-amber-500 transition-all duration-500"
                  style={{ width: `${statusInfo.percentage || 0}%` }}
                />
              </div>
            )}
          </div>
        </div>

        {/* Info */}
        <div className="px-3 pb-3">
          <h3 className="font-medium text-gray-800 text-sm truncate mb-1">
            {batch.title}
          </h3>
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-400">
              {formatDate(batch.created_at)}
            </span>
            {isProcessing && (
              <span className="text-xs text-amber-600 font-medium">
                {statusInfo.percentage || 0}%
              </span>
            )}
          </div>
        </div>

        {/* Delete button (hover) */}
        <button
          onClick={handleDelete}
          className="absolute top-4 right-4 p-1.5 bg-white hover:bg-red-50 rounded-lg opacity-0 group-hover:opacity-100 transition-all shadow-sm border border-gray-100"
          title="Excluir"
        >
          <Trash2 className="w-3.5 h-3.5 text-gray-400 hover:text-red-500 transition-colors" />
        </button>
      </div>
    </div>
  );
};

export default ProjectFolderCard;